// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import translate from "@insite/client-framework/Translate";
import { VariantTraitModel } from "@insite/client-framework/Types/ApiModels";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";

/* Valtech Custom Code */
import { swatchListItemStyles, swatchListStyles } from "@store/Themes/common/mixins/swatch";
import { swatchProps } from "@store/Themes/common/props/swatch";
/* Valtech Custom Code */

interface Props {
    variantSelection: SafeDictionary<string>;
    variantTrait: VariantTraitModel;
    updateVariantSelection: (traitValueId: string, variantTraitId: string) => void;
}

export interface ProductDetailsVariantButtonStyles {
    wrapper?: InjectableCss;
    swatchHeader?: InjectableCss;
    button?: ButtonPresentationProps;
    labelText?: TypographyPresentationProps;
    link?: LinkPresentationProps;
    // Valtech Custom Code
    swatchList?: InjectableCss;
    swatchListItem?: InjectableCss;
    selectedButton?: ButtonPresentationProps;
    unselectedButton?: ButtonPresentationProps;
}

export const variantButtonsStyles: ProductDetailsVariantButtonStyles = {
    wrapper: swatchProps.wrapper,
    labelText: swatchProps.label,
    swatchList: { css: swatchListStyles() },
    swatchListItem: { css: swatchListItemStyles() },
    selectedButton: { variant: "selected" as any },
    unselectedButton: { variant: "unselected" as any },
};

const styles = variantButtonsStyles;

const ProductDetailsVariantButton = ({ variantSelection, updateVariantSelection, variantTrait }: Props) => {
    return (
        <StyledWrapper {...styles.wrapper} key={variantTrait.id}>
            <StyledWrapper {...styles.swatchHeader}>
                <Typography {...styles.labelText}>{variantTrait.nameDisplay}</Typography>
                {/* Valtech Removed - Clear Selection */}
            </StyledWrapper>
            {/* Valtech Custom Code */}
            <StyledWrapper {...styles.swatchList} as="ul">
                {variantTrait.traitValues?.map(traitValue => {
                    const isSelected = variantSelection[variantTrait.id] === traitValue.id;

                    return (
                        <StyledWrapper as="li" {...styles.swatchListItem} key={`${traitValue.id}`}>
                            <Button
                                {...(isSelected ? styles.selectedButton : styles.unselectedButton)}
                                value={`${traitValue.id}`}
                                disabled={traitValue.isDisabled}
                                onClick={event =>
                                    updateVariantSelection(isSelected ? "" : event.currentTarget.value, variantTrait.id)
                                }
                            >
                                {traitValue.valueDisplay}
                            </Button>
                        </StyledWrapper>
                    );
                })}
            </StyledWrapper>
            {/* Valtech Custom Code */}
        </StyledWrapper>
    );
};

export default ProductDetailsVariantButton;
